<div class="login__container">
  <div class="login_panel">
    <span class="logo">
      <img src="../../../../assets/images/App-Logo.svg" alt="" />
    </span>

    <div class="form_header">Welcome </div>

    <div class="form_sub_header">Verify your invite by clicking the button below</div>

    @if (!isLoading$) {
      <button class="form_button" (click)="verify()">
        <img src="../../../../assets/icons/icon-log-out.svg" alt="" />
        <span>Verify</span>
      </button>
    }
    @if (isLoading$) {
      <button class="form_button">
        <span>Verifying...</span>
      </button>
    }
  </div>
</div>